import { type IOktaUser } from '../../constants/types/generatedTypesAliases'
import { baseGeneratedApi as api, type GetUsersApiArg, type GetUsersApiResponse } from './generated/usersApi'

const enhancedRtkApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getUsers: build.query<IOktaUser[], GetUsersApiArg>({
      query: (queryArg) => ({
        url: `/users`,
        params: {
          FirstName: queryArg.firstName,
          LastName: queryArg.lastName,
          Email: queryArg.email,
          ResourceTypes: queryArg.resourceTypes,
        },
      }),
      providesTags: ['User'],
      transformResponse(response: GetUsersApiResponse): IOktaUser[] {
        return response.map(({ id, status, profile, resourceTypes }) => ({
          id: id!, // id is always present
          status,
          resourceTypes,
          ...profile
        }))
      },
    })
  }),
})

export { enhancedRtkApi as baseApi }

export const {
  useGetUsersQuery
} = enhancedRtkApi
